export default __webpack_public_path__ + "static/media/Spiderdick.323b1e31.PNG";